import React from 'react';
import Styles from './styles.module.css';
import { RxCross2 } from 'react-icons/rx';

type AppModalProps = {
  onClose: () => void;
};

const AppModal: React.FC<AppModalProps> = ({ onClose }) => {
  return (
    <div className={Styles.overlay} onClick={onClose}>
      <div className={Styles.sheet} onClick={e => e.stopPropagation()}>

        <div className={Styles.handle} />

        <RxCross2 className={Styles.close} onClick={onClose} />

        <h3 className={Styles.title}>アプリから応募する</h3>

        <p className={Styles.desc}>
          説明会への参加・クーポンのご利用は<br />
          <strong>memorii works</strong> アプリから行えます。<br />
          下記よりアプリをダウンロードしてください。
        </p>

        <a
          className={Styles.store_btn}
          href="https://apps.apple.com/jp/app/memorii-works/id1578278781"
          target="_blank"
          rel="noopener noreferrer"
        >
          App Store で開く
        </a>

      </div>
    </div>
  );
};

export default AppModal;
